import { youtubeThumbnail } from '@/lib/channel';

export function VideoThumb({ video, className = '' }) {
  const frame = className || 'h-10 w-16 rounded-md';
  const src = youtubeThumbnail(video);
  if (!src) {
    return <span className={`${frame} shrink-0 bg-[#1a2030]`} />;
  }
  return (
    <img
      src={src}
      alt=""
      className={`${frame} shrink-0 object-cover bg-[#1a2030]`}
    />
  );
}
